import { fontPickerOptions } from 'shared/fonts';
import type { SelectOption } from './select-field';

/**
 * Шрифты инспекторов текста медиа-менеджера (`textbox-inspector`, `placeholder-text-inspector`).
 * Список, правила (кириллица, загрузка) и запасные шрифты живут в общем реестре
 * `shared/fonts/font-registry.ts` — его же читает редактор трансляций. `value` — голое имя
 * семейства, как оно хранится в `data.fontFamily` и на объекте Fabric.
 */
export const FONT_FAMILY_OPTIONS: SelectOption[] = fontPickerOptions('family');
